import type { VoidFunctionComponent } from 'react';

import InlineCopiableText from '../../../generic/CopiableText/InlineCopiableText';
import type { AnyTicket } from '../../../../../shared/issuesV2';

import { FossabotSectionLabel } from './FossabotFixOptionCard';

import styles from './FossabotTicketCreated.module.less';

type Props = {
  ticket: AnyTicket;
};

/**
 * The TICKET CREATED state of the fossabot remediation boxes: a copiable link
 * to the exported ticket. Jira tickets may have no URL (shared/issuesV2
 * JiraTicket.url is optional); in that case the ticket id renders as plain
 * text with no link, mirroring IssueTicketBadge. Jira tickets can also lack
 * an id at runtime despite the JiraTicket.id type (hydrate.ts casts a
 * nullable DB column), so render nothing rather than a bare "#".
 */
export const FossabotTicketCreated: VoidFunctionComponent<Props> = ({ ticket }) => {
  //  Only Jira tickets can lack a URL; custom tickets always carry one.
  if (ticket.type === 'jira' && !ticket.url) {
    if (!ticket.id) {
      return null;
    }

    return (
      <div>
        <FossabotSectionLabel>TICKET CREATED</FossabotSectionLabel>
        <span className={styles.ticketId}>#{ticket.id}</span>
      </div>
    );
  }

  return <InlineCopiableText label="TICKET CREATED" value={ticket.url} openLinkOnClick />;
};
